import { combineReducers } from 'redux';
import getCollection from './reducerCollection';
import sendMessage from './reducerMessage';

const rootReducer = combineReducers({
  collection: getCollection,
  message: sendMessage
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js